<template>
    <ChatAgentToolFrame>
        <div class="nadia-chat flex flex-col gap-1">
            <div class="nadia-chat text-valence-primary-500">Nice work on this section!</div>
            <div class="text-valence-grey-750">You can head back to the overview to continue with your next step.</div>
        </div>
        <BaseButton theme="primary" @click="handleClick">Back to Overview</BaseButton>
    </ChatAgentToolFrame>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import { PERFORMANCE_REVIEW_EVENT_PREFIX } from "~vue/Moments/constants";
import { openUrl } from "~vue/utils";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { inject } from "vue";

import ChatAgentToolFrame from "./ChatAgentToolFrame.vue";

interface Props {
    line?: {
        action_params?: {
            topic_code?: string | null;
            cta_id?: string | null;
            moment_id?: string | null;
        };
    };
}

const props = withDefaults(defineProps<Props>(), {
    line: undefined,
});

const coachingSessionUuid = inject<string>("coachingSessionUuid")!;

function handleClick() {
    logUserInteraction(
        `${PERFORMANCE_REVIEW_EVENT_PREFIX}back_to_overview_clicked`,
        {
            session_id: coachingSessionUuid,
            topic_code: props.line?.action_params?.topic_code ?? null,
            cta_id: props.line?.action_params?.cta_id ?? null,
            moment_id: props.line?.action_params?.moment_id ?? null,
        },
        coachingSessionUuid,
    );
    logUserInteraction(AmplitudeEventNames.PERFORMANCE_REVIEW_ENTRY_CLICKED, { entry_source: "back_to_overview" }, coachingSessionUuid);
    openUrl("/performance_management/");
}
</script>
